import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from './UserContext';

const AuthSuccess = () => {
  const navigate = useNavigate();
  const { fetchUserData } = useUser();

  useEffect(() => {
    // Fetch user data using the token stored in the HTTP-only cookie
    fetchUserData()
      .then(() => {
        // Redirect to the dashboard after successfully fetching user data
        navigate('/dashboard');
      })
      .catch((error) => {
        console.error('Failed to fetch user data after Google login', error);
        // Redirect to login page if fetching user data fails
        navigate('/login');
      });
  }, [navigate, fetchUserData]);

  return <div>Redirecting...</div>;
};

export default AuthSuccess;
